
import React from "react";
import { TableRow, TableCell } from "@/components/ui/table";

interface TableTotalRowProps {
  getGrandTotal: () => number;
}

const TableTotalRow: React.FC<TableTotalRowProps> = ({ getGrandTotal }) => {
  return (
    <TableRow>
      <TableCell colSpan={2} className="text-right font-bold">
        Total Points
      </TableCell>
      <TableCell colSpan={10} />
      <TableCell className="text-center font-bold">
        {getGrandTotal()}
      </TableCell>
    </TableRow>
  );
};

export default TableTotalRow;
